import MultiForm from '@admin/components/multiform'
import Notifications from './notifications'
import PropTypes from 'prop-types'
import Complete from './complete'
import Overview from './overview'
import React from 'react'

class New extends React.Component {

  static contextTypes = {
    modal: PropTypes.object
  }

  static propTypes = {
    program: PropTypes.object,
    program_id: PropTypes.number
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <MultiForm { ...this._getMultiForm() } />
  }

  _getMultiForm() {
    return {
      title: 't(Join Affiliate Program)',
      action: '/api/admin/team/affiliate',
      complete: Complete,
      method: 'POST',
      getSteps: this._getSteps.bind(this),
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess
    }
  }

  _getSteps(formdata) {
    return [
      { label: 't(Overview)', component: Overview },
      { label: 't(Notifications)', component: Notifications }
    ]
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(campaign) {
    this.context.modal.close()
  }

}

export default New
